import styles from "./borrowingCapacityResult.module.css";
import CalculatePV from "../../../helpers/calculatePV";
import HemDependant from "../../../helpers/hemDependant";
import HemSingleJoint from "../../../helpers/hemSingleJoint";
import CalculateNetIncome from "../../../helpers/calculateNetIncome";
import BorrowingCapacityResultPay from "./borrowingCapacityResultPay";

const BorrowingCapacityResult = ({
  numberOfApplicantsIn,
  numberOfDependantIn,
  annualIncome1In,
  annualIncome2In,
  monthlyRentalIncomeIn,
  creditCardLimitIn,
  personalLoanRepayIn,
  homeLoanRepayIn,
  yearIn,
  rateIn,
  serviceBufferIn,
}) => {
  let numberOfApplicants = Number(numberOfApplicantsIn);
  let numberOfDependant = Number(numberOfDependantIn);
  let annualIncome1 = Number(annualIncome1In);
  let annualIncome2 = numberOfApplicants === 2 ? Number(annualIncome2In) : 0;
  let monthlyRentalIncome = Number(monthlyRentalIncomeIn);
  let creditCardLimit = Number(creditCardLimitIn);
  let personalLoanRepay = Number(personalLoanRepayIn);
  let homeLoanRepay = Number(homeLoanRepayIn);
  let rate = Number(rateIn);
  let serviceBuffer = Number(serviceBufferIn);
  let year = Number(yearIn);

  const maxLoan = () => {
    if (numberOfApplicants === 0) return 0;
    if (annualIncome1 < 12000) return 0;

    let mpay = monthlyPay();

    if (mpay < 1) return 0;

    let result = CalculatePV(serviceBuffer + rate, year * 12, mpay);

    return result;
  };

  const monthlyPay = () => {
    if (numberOfApplicants === 0) return 0;

    let maxPayment = 0;

    let hemApplicats = HemSingleJoint(
      annualIncome1 + annualIncome2,
      numberOfApplicants
    );
    let hemDependant = HemDependant(numberOfApplicants, numberOfDependant);

    let expenses =
      creditCardLimit * 0.038 +
      homeLoanRepay +
      personalLoanRepay +
      hemDependant +
      hemApplicats;

    if (numberOfApplicants === 1) {
      let netIncome = CalculateNetIncome(annualIncome1);
      maxPayment = netIncome / 12 + monthlyRentalIncome - expenses;
    } else {
      let netIncome1 = CalculateNetIncome(annualIncome1);
      let netIncome2 = CalculateNetIncome(annualIncome2);
      maxPayment =
        (netIncome1 + netIncome2) / 12 + monthlyRentalIncome - expenses;
    }

    return maxPayment;
  };

  let maxLoanAvailable = maxLoan();

  const USDollar = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    maximumFractionDigits: 0,
    minimumFractionDigits: 0,
  });

  return (
    <div className={styles.result_view}>
      <div className="col-m-6">
        <label className={`form-label ${styles.label_main}`}>
          You may be able to borrow up to
        </label>
        <div className={styles.loan}>{USDollar.format(maxLoanAvailable)}</div>
      </div>
      <hr className={styles.hr} />
      <div className="col-m-6">
        <BorrowingCapacityResultPay
          loan={maxLoanAvailable}
          rate={rate}
          year={year}
        />
      </div>
      <hr className={styles.hr} />

      {/* Hyperlinked Button */}
      <a
        href="https://www.mortgagematrix.com.au/buy-with-confidence"
        target="_blank"
        rel="noopener noreferrer"
        className={styles.linkWrapper}
      >
        <button className={styles.infoButton}>
        Suggested Lenders <span className={styles.arrow}>→</span>
        </button>
      </a>

      <div className={styles.disclaimer}>
        This is an estimate of your borrowing capacity, if you choose a home
        loan with one of our panel of lenders, your borrowing capacity may vary
        based on your loan options. Learn more about how our calculator works
        below.
      </div>
    </div>
  );
};

export default BorrowingCapacityResult;
